/**
 * @shelf-version: 1.1.0
 */

import ScreenDimensions from './screen-dimensions'

export default ScreenDimensions
